import { render, staticRenderFns } from "./ToggleText.vue?vue&type=template&id=4838d253&scoped=true"
import script from "./ToggleText.vue?vue&type=script&lang=js"
export * from "./ToggleText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4838d253",
  null
  
)

export default component.exports